import FeedbackTextInput from "@/components/input/FeedbackTextInput"
import { FieldWithLabel } from "@/components/forms/FieldWithLabel"
import { View } from "react-native"

interface EmailAndPasswordFormProps {
  email?: string
  setEmail: (value: string | null | undefined) => void
  emailError: string | null
  password: string
  setPassword: (value: string | null | undefined) => void
  passwordError: string | null
}

export const EmailAndPasswordForm = ({
  email,
  setEmail,
  emailError,
  password,
  setPassword,
  passwordError,
}: EmailAndPasswordFormProps) => {
  return (
    <View className={"gap-5 mb-5"}>
      <FieldWithLabel
        label={"Email"}
        error={emailError}
        dark={true}
        required={true}
      >
        <FeedbackTextInput
          value={email}
          onChange={setEmail}
          keyboardType="email-address"
          returnKeyType="done"
          testID="register-email-text-input"
        />
      </FieldWithLabel>
      <FieldWithLabel
        label={"Password"}
        error={passwordError}
        dark={true}
        required={true}
      >
        <FeedbackTextInput
          value={password}
          onChange={setPassword}
          isSecured={true}
          returnKeyType="done"
          textContentType="oneTimeCode"
          testID="register-password-text-input"
        />
      </FieldWithLabel>
    </View>
  )
}
